import styled, {css} from 'styled-components'

export const StyledLoadMoreWrapper = styled.div`
    ${({theme: {spacing}}) => css`
        display: flex;
        justify-content: center;
        padding: ${spacing * 4}px 0;
    `}
`
